// var tus = window.tus;
import tus from 'tus-js-client';
var tusUpload = {
  _options: null,// 全局配置-恢复上传使用
  _file: null,// 全局文件-恢复上传使用
  getFileSuffix: function (name) {
    var index1 = name.lastIndexOf(".");
    var index2 = name.length;
    var suffix = '';
    if (index1 != -1) {
      suffix = name.substring(index1 + 1, index2);//后缀名
    }
    return suffix;
  },
  upload(url, file, fileName, data, headers, options) {
    options = options || {};
    const onProgress = headers.onProgress;
    delete headers['onProgress'];
    return new Promise((resovle, reject) => {
      const defaultOptions = {
        endpoint: options.endpoint || (url || ''),
        // uploadUrl: options.endpoint || (url || ''),
        retryDelays: options.retryDelays || [0, 1000, 3000, 5000],
        metadata: {
          filename: fileName,
          filetype: file.type,
          fileSuffix: tusUpload.getFileSuffix(file.name)
        },
        headers: headers || {},
        onError: function (error) {
          reject(error);
        },
        onProgress: function (bytesUploaded, bytesTotal) {
          var percentage = (bytesUploaded / bytesTotal * 100).toFixed(2)
          console.log(bytesUploaded, bytesTotal, percentage + "%");
          if (onProgress) {
            onProgress(bytesUploaded, bytesTotal, percentage);
          }
        },
        onSuccess: function () {
          resovle({
            name: tusUpload.tusUploadEle[file.uploadId].file.name,
            url: tusUpload.tusUploadEle[file.uploadId].url
          });
          tusUpload.tusUploadEle[file.uploadId] = null;
        }
      };
      defaultOptions.metadata = Object.assign({}, data, defaultOptions.metadata);
      options = Object.assign({}, defaultOptions, options);
      options.metadata = {
        filename: options.metadata.filename,
        filetype: options.metadata.filetype,
        nameDisplay: options.metadata.nameDisplay,
        fileSuffix: options.metadata.fileSuffix,
        user: options.metadata.user
      };
      tusUpload.tusUploadEle[file.uploadId] = new tus.Upload(file, options);
      tusUpload.tusUploadEle[file.uploadId].start();
    });
  },
  _tusFun(file, options) {
    tusUpload._options = options;
    tusUpload._file = file;
    tusUpload.tusUploadEle[file.uploadId] = new tus.Upload(file, options);
    tusUpload.tusUploadEle[file.uploadId].start();
  },
  pause(uploadId) {
    if (tusUpload.tusUploadEle[uploadId]) {
      tusUpload.tusUploadEle[uploadId].abort();
      // tusUpload.tusUploadEle[uploadId] = null;
    }
  },
  reset(uploadId) {
    tusUpload.tusUploadEle[uploadId] = null;
  },
  delete(uploadId) {
    if (tusUpload.tusUploadEle[uploadId]) {
      tusUpload.tusUploadEle[uploadId].abort();
      tusUpload.tusUploadEle[uploadId] = null;
    }
  },
  tusUploadEle: {}
};
export default tusUpload;